import React, { memo } from 'react';

/**
 * BackgroundEffects Component
 *
 * Previously rendered animated background effects (particles, orbs, circuit patterns).
 * Now returns null - background is handled by the global --bg-base CSS variable.
 * Component is kept for backwards compatibility with existing imports.
 */
const BackgroundEffects = memo(() => {
  return null;
});

BackgroundEffects.displayName = 'BackgroundEffects';

export default BackgroundEffects;
